/**
 * PreviewTileGrid — gradient-shell container that holds a row of PreviewTiles.
 * Matches the soft purple/orange tinted card from Figma 11248:513839.
 *
 * Mobile: 1 column. sm: 2 columns. lg+: 3 columns.
 */

import React from 'react';

export interface PreviewTileGridProps {
  children: React.ReactNode;
  /** Override the default 3-column max — useful when a day has 4 courses. */
  maxColumns?: 2 | 3 | 4;
}

export default function PreviewTileGrid({ children, maxColumns = 3 }: PreviewTileGridProps) {
  const lgCols = maxColumns === 2 ? 'lg:grid-cols-2' : maxColumns === 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-3';
  return (
    <section
      className="relative rounded-[28px] p-[10px] sm:p-3"
      style={{
        background:
          'linear-gradient(to right, rgb(var(--color-primary) / 0.20), rgb(var(--color-secondary) / 0.20))',
      }}
    >
      <div className="rounded-[20px] bg-background-primary px-4 sm:px-7 py-5 sm:py-7">
        <div className={`grid grid-cols-1 sm:grid-cols-2 ${lgCols} gap-4 sm:gap-6`}>
          {children}
        </div>
      </div>
    </section>
  );
}
